import React from "react";
import DashboardAdsCard from "../../../../components/common/AdsCard/DashboardAdsCard";
import DefaultImage from "../../../../assets/img/default-image.jpg";
import { useSelector } from "react-redux";
import { AdminHeaderAction, AdminLinkAction } from "../../../AdminDashboard/shared/adminUx";
import {
  BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS,
} from "../../shared/businessLayoutSpec";

const PostReview = ({ setStep, handlePost }) => {
  const {
    postTitle,
    description,
    mainCategory,
    subCategory,
    portfolioImages,
    location,
    range,
    postTags,
  } = useSelector((state) => state.createPost);

  const userPlan = useSelector((state) => state.user.userPlan);

  const handlePublishClick = () => {
    handlePost(true);
  };

  return (
    <>
      <div className="w-full flex items-center justify-center">
        <DashboardAdsCard
          type="Featured"
          postTitle={postTitle ?? ""}
          serviceName={mainCategory?.name ?? ""}
          serviceDescription={description ?? ""}
          category={subCategory?.name ?? ""}
          Images={portfolioImages ?? null}
          companyLogo={DefaultImage}
          location={location}
          range={range}
          tags={postTags}
          shareButton={false}
          saveButton={false}
          userPlan={userPlan}
        />
      </div>
      <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
        <AdminLinkAction type="button" onClick={() => setStep(6)}>
          Back
        </AdminLinkAction>
        <AdminHeaderAction type="button" className="w-full" onClick={handlePublishClick}>
          Publish
        </AdminHeaderAction>
      </div>
    </>
  );
};

export default PostReview;
